export default __webpack_public_path__ + "static/media/partner17.217ef8e8.webp";